// libraries
import React from 'react';
import {render} from 'react-dom';
import {Provider} from 'react-redux';
import createHistory from 'history/createBrowserHistory';
import {routerMiddleware} from 'react-router-redux';
require('es6-promise').polyfill();

// shared
import {ready} from 'shared/utils';
import pageView from 'shared/page-view';
import AccessibilityAnnouncement from 'shared/components/accessibility-announcement';

// root-app
import RootApp from './components';
import configureStore from '../store/configure-store';

ready(() => {
  if (!document.getElementById('root-app')) {
    return;
  }

  const browserHistory = createHistory();
  const middleware = routerMiddleware(browserHistory);
  const store = configureStore({}, middleware);

  // trigger initially so it happens on landing
  pageView(location.pathname);

  browserHistory.listen(({pathname}) => {
    pageView(pathname);
    window.analytics.page();
  });

  render(
    <Provider store={store}>
      <React.Fragment>
        <AccessibilityAnnouncement />
        <RootApp browserHistory={browserHistory} />
      </React.Fragment>
    </Provider>,
    document.getElementById('root-app')
  );
});
